<template>
  <v-container class="fill-height justify-center" fluid>
    <v-card tile width="500">
      <v-card-title>
        <span class="headline">{{ $t("resetPasswordTitle") }}</span>
      </v-card-title>
      <v-card-text>
        <v-form @keyup.native.enter="submit">
          <v-text-field
            :label="$t('resetPasswordPassword') + '*'"
            name="password"
            prepend-icon="mdi-lock"
            type="password"
            v-model="resetData.password"
            :error-messages="passwordErrors"
            required
            @input="$v.resetData.password.$touch()"
            @blur="$v.resetData.password.$touch()"
          ></v-text-field>
          <v-text-field
            :label="$t('resetPasswordConfirm') + '*'"
            name="password_confirm"
            prepend-icon="mdi-lock"
            type="password"
            v-model="resetData.password_confirm"
            :error-messages="paswordRepeatErrors"
            required
            @input="$v.resetData.password_confirm.$touch()"
            @blur="$v.resetData.password_confirm.$touch()"
          ></v-text-field>
          <small>* {{ $t("validation") }}</small>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          :disabled="$v.resetData.$invalid"
          color="green darken-1"
          text
          @click="submit"
          >{{ $t("btnApply") }}</v-btn
        >
        <v-btn color="red darken-1" text @click="clear">{{
          $t("btnClear")
        }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, minLength, sameAs } from "vuelidate/lib/validators";
import { mapActions } from "vuex";
import store from "../store";

export default {
  name: "ResetPassword",

  mixins: [validationMixin],

  beforeRouteEnter: (to, from, next) => {
    store
      .dispatch("checkResetPasswordHash", to.params.hash)
      .then((response) => {
        if (response.status == 200) {
          next();
        } else {
          next("login");
        }
      });
  },

  validations: {
    resetData: {
      password: { required, minLength: minLength(6) },
      password_confirm: { required, sameAsPassword: sameAs("password") },
    },
  },

  computed: {
    passwordErrors() {
      const errors = [];
      if (!this.$v.resetData.password.$dirty) return errors;
      !this.$v.resetData.password.required &&
        errors.push(this.$i18n.t("validationRequired"));
      !this.$v.resetData.password.minLength &&
        errors.push(this.$i18n.t("validationPasswordLength"));
      return errors;
    },
    paswordRepeatErrors() {
      const errors = [];
      if (!this.$v.resetData.password_confirm.$dirty) return errors;
      !this.$v.resetData.password_confirm.required &&
        errors.push(this.$i18n.t("validationRequired"));
      !this.$v.resetData.password_confirm.sameAsPassword &&
        errors.push(this.$i18n.t("validationPasswordMatch"));
      return errors;
    },
  },

  data: () => ({
    resetData: {
      password: "",
      password_confirm: "",
    },
  }),

  methods: {
    ...mapActions(["checkResetPasswordHash", "resetPassword"]),
    submit() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.resetPassword({
          key: this.$route.params.hash,
          data: this.resetData,
        });
      }
    },
    clear() {
      this.$v.$reset();
      this.authData.password = "";
      this.authData.password_repeat = "";
    },
  },
};
</script>
